import React from 'react';
import { BlockedLinkWrapper } from '@cko/dashboard-shared';
import { AvailableMenuItem } from '../../../../../providers/NavigationProvider/types';
import { getMenuItemTestId } from '../../../../../utils/getMenuItemTestId';

import { TabMenuLink } from './TabMenuLink';
import { StyledTextStatus, Wrapper } from './TabbedMenu.styles';

type Props = {
  menuItems: Array<AvailableMenuItem>;
};

export const TabbedMenu = ({ menuItems }: Props) => (
  <Wrapper>
    {menuItems.map((menuItem) => {
      if (menuItem.type === 'internal_link') {
        const tabbedMenuItemTestId = getMenuItemTestId('tabbed', menuItem.label);
        return (
          <BlockedLinkWrapper
            key={menuItem.path}
            linkType="primary"
            requiredAccountLevels={menuItem.requiredAccountLevels}
            to={menuItem.path}
          >
            {({ isBlocked }) => (
              <TabMenuLink
                to={menuItem.path}
                isBlocked={isBlocked}
                data-testid={tabbedMenuItemTestId}
              >
                {menuItem.label}
                {menuItem.statusLabel && (
                  <StyledTextStatus variant="highlight">{menuItem.statusLabel}</StyledTextStatus>
                )}
              </TabMenuLink>
            )}
          </BlockedLinkWrapper>
        );
      }

      return <React.Fragment key={menuItem.label}></React.Fragment>;
    })}
  </Wrapper>
);
